import {
  FactorType,
  StateType,
} from '@wix/ambassador-iam-authentication-v1-authentication/types';

/**
 * The registerV2 field and the state added by identity#5080, which the generated client does not carry yet
 * (latest published is 1.0.216). Delete this file and use the generated members once the package is bumped.
 */
export const REQUIRE_REGISTRATION_FACTOR =
  'REQUIRE_REGISTRATION_FACTOR' as StateType;

/** `registerV2` chooses the factor to register with; unset is read as PASSWORD. */
export type RegistrationFactorField = { factorType: FactorType };

/** `stateData.requireRegistrationFactorData` on a paused registration. */
export type RequireRegistrationFactorData = {
  factorType?: FactorType;
  verificationChallengeData?: { hint?: string | null } | null;
};
